import { render, staticRenderFns } from "./CncIcon.vue?vue&type=template&id=5fc3e381"
import script from "./CncIcon.vue?vue&type=script&lang=js"
export * from "./CncIcon.vue?vue&type=script&lang=js"
import style0 from "./CncIcon.vue?vue&type=style&index=0&id=5fc3e381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports